export default {
    updateAttendance: 'แก้ไขสถานะการเข้างาน',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    profile: 'ข้อมูลส่วนตัว',
    status: 'สถานะ',
    date: 'วันที่',
    name: 'ชื่อ - นามสกุล',
    group: 'กลุ่ม',
    department: 'แผนก',
    ontime: 'ตรงเวลา',
    late: 'สาย',
    absent: 'ขาด',
    activityLog: 'ประวัติกิจกรรม',
    thereIsNoActivityLog: 'ไม่มีประวัติกิจกรรม',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด',
    checkIn: 'เวลาเข้างาน',
    checkOut: 'เวลาออกงาน',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    errorTime: 'เกิดข้อผิดพลาด',
    errorSeleteTime: 'เวลาที่เลือกเกิดข้อผิดพลาด',
    seletePeriod: 'กรุณาเลือกช่วงเวลาให้อยู่ในช่วง',
    seleteBefore: 'กรุณาเลือกช่วงเวลาให้ถูกต้อง',
    seletemoreThanTimeStart: 'กรุณาเลือกช่วงเวลาเลิกงานหลังจากเวลา'
}
